(function () {
  function initAll(root) {
    var scope = root || document;
    var grids = scope.querySelectorAll('[data-problem-slider]');
    grids.forEach(initSlider);
  }

  function initSlider(grid) {
    if (!grid || grid.dataset.sliderBound === '1') return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.problem-card'));
    if (cards.length < 2) return;

    grid.dataset.sliderBound = '1';

    var mq = window.matchMedia('(max-width: 900px)');
    var index = 0;
    var timer = null;
    var resumeTimer = null;
    var inView = false;

    function isMobile() {
      return mq.matches;
    }

    function gap() {
      var styles = window.getComputedStyle(grid);
      return parseFloat(styles.columnGap || styles.gap) || 14;
    }

    function padLeft() {
      return parseFloat(window.getComputedStyle(grid).paddingLeft) || 24;
    }

    function slideWidth() {
      return cards[0].getBoundingClientRect().width + gap();
    }

    function goTo(i, instant) {
      if (!isMobile()) return;
      index = ((i % cards.length) + cards.length) % cards.length;
      var left = index * slideWidth();
      try {
        grid.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      } catch (e) {
        grid.scrollLeft = left;
      }
      /* Fallback if scroll didn't move (some mobile browsers) */
      window.setTimeout(function () {
        if (!isMobile()) return;
        if (Math.abs(grid.scrollLeft - left) > 8) {
          grid.scrollLeft = left;
        }
      }, instant ? 0 : 350);
    }

    function stop() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function schedule() {
      stop();
      if (!isMobile() || !inView) return;

      timer = window.setTimeout(function () {
        if (!isMobile() || !inView) return;

        if (index >= cards.length - 1) {
          goTo(0, true);
          schedule();
          return;
        }

        goTo(index + 1, false);
        schedule();
      }, 2800);
    }

    function start() {
      if (!isMobile()) return;
      inView = true;
      schedule();
    }

    function pauseTemp() {
      stop();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        if (!isMobile()) return;
        var width = slideWidth() || 1;
        index = Math.round(grid.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > cards.length - 1) index = cards.length - 1;
        inView = true;
        schedule();
      }, 3500);
    }

    grid.addEventListener('pointerdown', pauseTemp, { passive: true });
    grid.addEventListener('touchstart', pauseTemp, { passive: true });
    grid.addEventListener('wheel', pauseTemp, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              inView = true;
              schedule();
            } else {
              inView = false;
              stop();
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
      );
      io.observe(grid);
    } else {
      inView = true;
    }

    function onMq() {
      stop();
      index = 0;
      if (isMobile()) {
        grid.scrollLeft = 0;
        if (inView) schedule();
      }
    }

    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);

    /* Kick off immediately on mobile */
    if (isMobile()) {
      grid.scrollLeft = 0;
      inView = true;
      window.setTimeout(function () {
        goTo(0, true);
        schedule();
      }, 200);
    }
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Extra safety: restart after full load (fonts/images can affect widths) */
  window.addEventListener('load', function () {
    var grids = document.querySelectorAll('[data-problem-slider]');
    grids.forEach(function (grid) {
      if (grid.dataset.sliderBound === '1' && window.matchMedia('(max-width: 900px)').matches) {
        /* nudge schedule by dispatching a custom re-check via scrollLeft reset only if stuck at 0 forever handled by timer */
      }
    });
  });
})();
